<template>
  <section class="mb-6">
    <div class="flex items-center justify-between mb-3">
      <h3 class="text-sm font-medium text-slate-700">
        {{ $t('messages.quickValuation.shortReport.photosSection.title') }}
      </h3>
      <small class="text-slate-500">
        {{ $t('messages.quickValuation.shortReport.photosSection.hint') }}
      </small>
    </div>
    <PhotoUploadComponent
      :object-id="evaluationId"
      photo-type="front"
      data-testid="qv-short-report-photos"
      @photos-changed="$emit('photos-changed', $event)"
    />
  </section>
</template>

<script setup>
import PhotoUploadComponent from '@/components/PhotoUploadComponent.vue'

defineProps({
  evaluationId: { type: Number, required: true },
})

defineEmits(['photos-changed'])
</script>
